import http from "@/shared/services/http.config";

export const updateGeneral = (payload: Record<string, any>) =>
  http.post("/setup-profile/update-general", payload).then((res) => res.data);

export const updateBusinessAddress = (payload: Record<string, any>) =>
  http.post("/setup-profile/business-address", payload).then((res) => res.data);

export const updatePassword = (payload: Record<string, any>) =>
  http.post("/setup-profile/update-password", payload).then((res) => res.data);

export const uploadLogo = (payload: FormData) =>
  http.post("/setup-profile/upload-logo", payload).then((res) => res.data);

export const paymentCredential = (payload: Record<string, any>) =>
  http.post("/setup-profile/payment-credential", payload).then((res) => res.data);

export const serviceList = (payload: Record<string, any>) =>
  http.post("/setup-profile/service-list", payload).then((res) => res.data);

export const servicePackages = (payload: Record<string, any>) =>
  http.post("/setup-profile/service-packages", payload).then((res) => res.data);

export const schedulePackages = (payload: Record<string, any>) =>
  http.post("/setup-profile/schedule-packages", payload).then((res) => res.data);

export const taxSettings = (payload: Record<string, any>) =>
  http.post("/setup-profile/tax-settings", payload).then((res) => res.data);

export const schedule = (payload: Record<string, any>) =>
  http.post("/setup-profile/schedule", payload).then((res) => res.data);

export const fetchVendorInfo = (params: Record<string, any> = {}) =>
  http.get("/vendors/info", { params }).then((res) => res.data);
